import React from 'react'
import * as Icons from "react-icons/vsc"
import * as Icon1 from "react-icons/io5";

import { useDispatch } from 'react-redux';
import { NavLink, matchPath, useLocation } from 'react-router-dom';
import {resetCourseState} from "../../../slices/courseSlice"
const SidebarLink = ({link, iconName}) => {
    const Icon = Icons[iconName] || Icon1[iconName];
    const location = useLocation();
    const dispatch = useDispatch();

    const matchRoute = (route) => {
        return matchPath({path: route}, location.pathname)
    }


  return (
    <NavLink
    to={link.path}
    className={`relative px-6 py-2 text-sm font-medium 
    ${matchRoute(link.path) ? "bg-yellow-800 text-yellow-50 border-l-2 border-yellow-50" : "bg-opacity-0" }
    transition-all duration-200`}
    onClick={() => (dispatch(resetCourseState()))}
    >
        <span className={`absolute left-0 top-0 h-full w-[0.2rem] bg-yellow-50 ${matchRoute(link.path) ? "opacity-100" : "opacity-0"}`}></span>

        <div className='flex items-center gap-x-2'>
            <Icon className="text-lg" />
            <span>{link.name}</span>
        </div>
    </NavLink>
  )
}

export default SidebarLink